export default __webpack_public_path__ + "images/watermark-logo-white.04ab0c6d75a0281cc74363ba6a6949fd.png";